module.exports = __webpack_public_path__ + "img/diagram-beach.532cfbbc.png";